import { Box, LoadingBubbles } from '@domain-group/suit-theme'

import ArtworkPagePreview from '@components/ArtworkPagePreview'

import type { ArtworkPagePreviewRenderParams } from '@components/ArtworkPagePreview'
import type { ArtworkPageModel } from '@models/types'

interface ArtworkPageProps {
  artworkPage: ArtworkPageModel,
}

const ArtworkPage = (props: ArtworkPageProps) => {
  const { artworkPage } = props

  return (
    <Box
      height="100%"
      borderRadius={5}
      border="1px solid"
      borderColor="lineColor"
      backgroundColor="whiteGrey"
      flexShrink={0}
      width="100%"
    >
      <ArtworkPagePreview
        artworkPage={artworkPage}
        configOptions={{
          ablyPublicKey: process.env.REACT_APP_ABLY_ARTWORK_BUILDER_PUBLIC_KEY || '',
        }}
        height="100%"
        width="100%"
      >
        {(params: ArtworkPagePreviewRenderParams) => {
          const { buildingRef } = params

          // Loading
          if (buildingRef.current){
            return (
              <LoadingBubbles color="bodyFontLightColor" />
            )
          }

          return null
        }}
      </ArtworkPagePreview>

    </Box>
  )
}

export default ArtworkPage
